import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {EnumerationService} from '../services/enumeration.service';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcRestService} from 'exc-rest-v2';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styles: [
  ]
})
export class CompanyComponent extends ExcTranslation implements OnInit {
  @ViewChild('VCcompanyForm', {read: CompanyComponent}) VCcompanyForm!: CompanyComponent;

  @Input()
  editMode = false;
  @Input()
  checkview: any | undefined;
  @Input()
  set showCompanyForm(bool: boolean) {
    if (bool !== undefined) {
      this._showCompanyForm = bool;
    }
    // this.chDecRef.detectChanges();
  }
  get showCompanyForm(): boolean {
    return this._showCompanyForm;
  }
  /*              Input-Company              */
  @Input()
  set CompanyData(data: any) {
    this.init = data ? !data.compID : true;
    this._CompanyData = data ? data : this.initialModel;
    if (!this.init) {
      this.CompanyDataClone = this.clone(data);
    }
  }

  get CompanyData(): any {
    return this._CompanyData;
  }
  set CompanyDataClone(data: any) {
    this.initialModel =  data;
    // this.chDecRef.markForCheck();
  }
  get CompanyDataClone(): any {
    return this.initialModel;
  }
  @Input()
  canChangeView = false;
  @Input()
  compToRcpt = true;
  @Input()
  compLinkRcpt = false;
  init = true;
  duplicate = false;
  _CompanyData = {};
  _showCompanyForm = true;

  initialModel = {
    compName: ''
    , compAdressline1: ''
    , compAdressline2: ''
    , compAdressline3: ''
    , compAdressline4: ''
    , compZip: ''
    , compLocation: ''
    , compCountry: 0
    , compContactNumber: ''
    , compContactMail: ''
    , compWebsite: ''
    , compTaxID: ''
    , compSalesTaxID: ''
    , compRegisterNo: ''
    , compDEL: 0
    , compID: undefined
  };
  countryList: any[] = [];

  constructor(
    public chDecRef: ChangeDetectorRef,
    private modalService: ExgModalService,
    private excRestService: ExcRestService,
    public enumSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {
    this.CompanyData = this.initialModel;
    this.countryList = this.enumSvc.getEnumerationList('Country');
  }

  get compChanged(): boolean {
    return JSON.stringify(this.CompanyDataClone) !== JSON.stringify(this.CompanyData);
  }

  companyChanged = (): boolean => {
    return JSON.stringify(this.CompanyDataClone) !== JSON.stringify(this.CompanyData);
  }

  cancelChanges = (): void => {
    this.CompanyData  = this.initialModel;
  }

  beforeClose = () => {
    const changed = this.companyChanged();

    if (changed && !this.init) {
      this.modalService.showSimple(
        this.getRessource('Sure'), this.getRessource('Unsaved Changes'),
        true, true, this.getGlobal('Save'), this.getGlobal('Cancel'))
        .subscribe((value: boolean) => {
          if (value) {
            if (this.compChanged) {
              this.checkview.receiptCompany(this.CompanyDataClone);
            }
          } else {
            this.cancelChanges();
          }
        });
    }
  }

  clone(cloneObj: any): any {
    return JSON.parse(JSON.stringify(cloneObj));
  }

  validate = (): boolean => {
    if (this.companyChanged() || !this.CompanyDataClone?.compID) {
      if (this.CompanyDataClone.compName && this.CompanyDataClone.compName.length >= 1) {
        return this.validateTaxIDs();
      }
    }
    return false;
  }

  validateTaxIDs = (): boolean => {
    if (this.CompanyDataClone.compSalesTaxID && this.CompanyDataClone.compSalesTaxID.length >= 1) {
      return true;
    } else if (this.CompanyDataClone.compTaxID && this.CompanyDataClone.compTaxID.length >= 1) {
      return true;
    }
    return false;
  }

  checkDuplicates(dataTableObj?: any): void {
    if (this.init) {
      this.excRestService
        .get(
          this.excRestService.computeUrl('CompanyDuplicates', {
            compZip: this.CompanyDataClone.compZip,
            compLocation: this.CompanyDataClone.compLocation,
            compSalesTaxID: this.CompanyDataClone.compSalesTaxID,
            compTaxID: this.CompanyDataClone.compTaxID
          }),
          {}
        )
        .subscribe((res: any) => {
          if (res && res.data)  {
            if (res.data.Company && res.data.Company.length > 0) {
              this.duplicate = true;
              if (dataTableObj) {
                dataTableObj.loadData(res.data.Company, res.paging.Company);
              }
            } else {
              this.duplicate = false;
            }
          }
        });
    }
  }

  companyShowDuplicates(): void {
    if (this.duplicate) {
      this.modalService
        .show('ReceiptCompanyListComponent', {
          rcptLink: this.compLinkRcpt,
          checkviewFunction: (obj: any) => {
            this.checkDuplicates(obj);
          },
        })
        .subscribe((result: any) => {
          if (!this.compLinkRcpt || result.compDoDel) {
            if (result && (result.compToRcpt || result.compDoDel)) {
              this.checkview.receiptCompany(result);
            }
          } else {
            if (result && (result.compLinkRcpt)) {
              this.checkview.receiptCompanyLinkCU(result.compID);
            }
          }
        });
    }
  }

  isNumberString(value: unknown): boolean {
    if (!value) {
      return false;
    }
    const s = String(value).trim();

    // erlaubt:  "12", "-12", "12.3", "12,3"
    // nicht erlaubt: "", "12a", "1 2"
    return s !== '' && !Number.isNaN(Number(s.replace(',', '.')));
  }
}
